import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext(null);

const DEFAULT = process.env.REACT_APP_DEFAULT_THEME || "teal-medical";
const DARK_THEMES = ["mono-dark"];
const LIGHT_ONLY = ["mono-light"];

export function ThemeProvider({ children }) {
  const [palette, setPalette] = useState(() => localStorage.getItem("po_palette") || DEFAULT);
  const [dark, setDark] = useState(() => localStorage.getItem("po_dark") === "1");

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute("data-theme", palette);
    const forceDark = DARK_THEMES.includes(palette);
    const forceLight = LIGHT_ONLY.includes(palette);
    const isDark = forceDark ? true : forceLight ? false : dark;
    root.classList.toggle("dark", isDark);
    localStorage.setItem("po_palette", palette);
    localStorage.setItem("po_dark", dark ? "1" : "0");
  }, [palette, dark]);

  return (
    <ThemeContext.Provider value={{ palette, setPalette, dark, setDark }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
